import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';

import skeletons from './Skeletons';
import ErrorStateWithReload from '../../../../components/ErrorStateWithReload';
import CompanyMediaObject from './CompanyMediaObject';

import { fetchCurrentForecasts, fetchKpiForecasts, selectKpiForecast } from '../../actions';
import {
  kpiForecastsSettingsSelector,
  kpiForecastsSelector,
  activeForecastSelector,
} from '../../selectors';

const renderForecastTitle = ({ name, ticker, icon_url }) =>
  (
    <CompanyMediaObject
      name={name}
      ticker={ticker}
      icon={icon_url}
    />
  );

const ForecastsSidebar = () => {
  const dispatch = useDispatch();

  const { pending, error } = useSelector(kpiForecastsSettingsSelector);
  const forecasts = useSelector(kpiForecastsSelector);
  const activeForecast = useSelector(activeForecastSelector);

  const handleForecastSelect = (forecast) => {
    dispatch(selectKpiForecast(forecast));
  };

  // Initial fetch
  useEffect(() => {
    if (activeForecast) {
      dispatch(fetchCurrentForecasts({
        ticker: activeForecast.ticker,
        kpi_id: activeForecast.kpis?.[0]?.kpi_id,
      }));
    } else {
      dispatch(fetchKpiForecasts());
    }
  }, []);

  return (
    <div className="kpi-forecasts-block__sidebar">
      {error ? <ErrorStateWithReload /> : (
        <>
          <div className="kpi-forecasts-block__sidebar-box">
            <div className="kpi-forecasts-block__sidebar-heading">
              <p className="heading-capitalize">My Forecasts</p>
            </div>
            <div className="kpi-forecasts-block__sidebar-list">
              {pending && skeletons.sidebar}
              {!pending && forecasts.my_forecasts?.map((forecast) => {
                const { name, ticker, icon_url } = forecast;

                return (
                  <div
                    key={name + ticker}
                    className={cx('kpi-forecasts-block__sidebar-list-item', { active: ticker === activeForecast?.ticker })}
                    onClick={() => handleForecastSelect(forecast)}
                  >
                    {renderForecastTitle({ name, ticker, icon_url })}
                  </div>
                );
              })}
            </div>
          </div>
          {(pending || (!pending && forecasts.all_forecasts?.length > 0)) && (
            <div className="kpi-forecasts-block__sidebar-box">
              <div className="kpi-forecasts-block__sidebar-heading">
                <p className="heading-capitalize">All Forecasts</p>
              </div>
              <div className="kpi-forecasts-block__sidebar-list disabled">
                {pending && skeletons.sidebar}
                {!pending && forecasts?.all_forecasts.map(({ name, ticker, icon_url }) => (
                  <div
                    key={name + ticker}
                    className="kpi-forecasts-block__sidebar-list-item"
                  >
                    {renderForecastTitle({ name, ticker, icon_url })}
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ForecastsSidebar;
